import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { ImageLoader } from 'tradera/components/image-lazy-load/image-loader';
import { EmptyImage } from 'tradera/apps/tradera/messaging/components/empty-image/empty-image';
import ALink from 'tradera/components/alink/alink';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';

type NewMessageHeaderProps = {
    recipientId: number;
    recipientAlias: string;
    itemTitle: string;
    itemImageUrl: string;
    itemSellerId?: number;
    purchaseOrderId?: string;
};

export const NewMessageHeader = ({
    recipientId,
    recipientAlias,
    itemTitle,
    itemImageUrl,
    itemSellerId,
    purchaseOrderId,
}: NewMessageHeaderProps) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();

    return (
        <div className="d-flex flex-column align-items-center my-md-0 border-bottom pb-2">
            <div className="w-100">
                <div className="d-flex align-items-center">
                    <h4
                        className="text-truncate text-styled my-0 mr-auto "
                        aria-label="recipient">
                        <ALink
                            href={`/profile/items/${recipientId}/${recipientAlias}`}
                            useLink>
                            {recipientAlias}
                        </ALink>
                    </h4>
                    {purchaseOrderId && itemSellerId && (
                        <Button
                            theme="unbutton"
                            round
                            className={`my-1 d-flex align-items-center justify-content-center`}
                            target="_blank"
                            rel="noopener noreferrer"
                            href={toLocalizedUrl(
                                `/my/order/${purchaseOrderId}`,
                            )}>
                            <InfoIcon className="icon-md" />
                        </Button>
                    )}
                </div>
                <div className="d-flex align-items-center justify-content-between">
                    <span>
                        <strong>
                            {t('messaging_regarding_short')}:&nbsp;
                            {itemTitle}
                        </strong>
                    </span>
                    <div style={{ height: '42px', width: '42px' }}>
                        <ImageLoader
                            className="w-100"
                            src={itemImageUrl}
                            fallback={<EmptyImage />}
                            alt={itemTitle}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
